/**
 * Quyền HomeTools, dùng chung catalog với hệ thống quản lý đơn
 * (QuanLyDonHangDuni-main/docs/domains/permissions.md). Server là nơi kiểm tra
 * thật; client chỉ dùng để ẩn/hiện trang và nút.
 */
export const PERMISSIONS = {
  schedule: 'schedule.manage',
  attendance: 'attendance.manage',
  bulletins: 'bulletins.manage',
  files: 'files.share',
  holidays: 'holidays.manage',
  partTimeSalary: 'salary.part_time.manage',
  employees: 'employees.manage',
} as const;

export type PermissionMap = Record<string, boolean>;

export function hasAny(permissions: PermissionMap | undefined, keys: readonly string[]): boolean {
  return Boolean(permissions) && keys.some((key) => permissions![key] === true);
}

export interface ManagerPage {
  path: string;
  label: string;
  permissions: readonly string[];
  inNavigation: boolean;
}

export const MANAGER_PAGES: ManagerPage[] = [
  { path: '/schedule', label: 'Lịch làm việc', permissions: [PERMISSIONS.schedule], inNavigation: true },
  {
    path: '/management-checkinout',
    label: 'Điểm danh',
    permissions: [PERMISSIONS.attendance, PERMISSIONS.partTimeSalary, PERMISSIONS.holidays, PERMISSIONS.employees],
    inNavigation: true,
  },
  { path: '/admin-bulletins', label: 'Bảng tin & Nhiệm vụ', permissions: [PERMISSIONS.bulletins], inNavigation: true },
  { path: '/admin-discipline-rewards', label: 'Thống kê lỗi / thưởng', permissions: [PERMISSIONS.bulletins], inNavigation: true },
  { path: '/vault-share-2026', label: 'Chia sẻ file', permissions: [PERMISSIONS.files], inNavigation: false },
];

export function pagePermissions(path: string): readonly string[] {
  return MANAGER_PAGES.find((page) => page.path === path)?.permissions ?? [];
}

/** Trang đầu tiên sau đăng nhập: trang quản lý đầu tiên được phép, nếu không thì trang điểm danh. */
export function homePathFor(permissions: PermissionMap | undefined): string {
  const page = MANAGER_PAGES.find((item) => item.inNavigation && hasAny(permissions, item.permissions));
  return page?.path ?? '/checkinout';
}
